<p-toast></p-toast>
<p-dialog header="Hardcopy Activity Audit" [(visible)]="isHardCopyActivityAuditModalShow" [draggable]="false"
    [style]="{ width: '100vw', height: '98vh' }" (onHide)="closeHardCopyActivityAuditModal()" [modal]="true"
    id="hardCopyActivityAuditModal">
    <app-hardcopyactivity-audit-trial [hardcopyactivityId]="hardCopyActivityId">
    </app-hardcopyactivity-audit-trial>
</p-dialog>